import { History } from '@/features/history';

/**
 * Recent-reads page. Delegates to the History component which groups by
 * date and supports per-row remove + clear-all.
 */
export function HistoryPage() {
  return (
    <div className="flex flex-col gap-4">
      <h1 className="text-2xl font-bold">Reading history</h1>
      <History />
    </div>
  );
}
